import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdminGuard } from './components/AdminGuard';
import { Layout } from './components/Layout';
import { AuditLog } from './routes/AuditLog';
import { Dashboard } from './routes/Dashboard';
import { Login } from './routes/Login';
import { Monitoring } from './routes/Monitoring';
import { OrgDetail } from './routes/Organizations/Detail';
import { OrgList } from './routes/Organizations/List';
import { Unauthorized } from './routes/Unauthorized';
import { UserDetail } from './routes/Users/Detail';
import { UserList } from './routes/Users/List';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route element={<AdminGuard />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/organizations" element={<OrgList />} />
            <Route path="/organizations/:id" element={<OrgDetail />} />
            <Route path="/users" element={<UserList />} />
            <Route path="/users/:id" element={<UserDetail />} />
            <Route path="/monitoring" element={<Monitoring />} />
            <Route path="/audit-log" element={<AuditLog />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
